<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content" style="min-height: 0">
        <a-tabs v-model="activeKey" @change="changeTabs">
          <a-tab-pane
            v-if="isEdit"
            key="OrderStatusFlow"
            :tab="$t(`form.OrderStatusFlow`)"
          ></a-tab-pane>
          <a-tab-pane key="ArrivalDetail" :tab="$t(`form.PurchaseReturnInformation`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`form.ProductInfo`)"></a-tab-pane>
          <a-tab-pane key="LogisticsInfo" :tab="$t(`物流信息`)"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="content-overflow mt10">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData" v-show="activeKey !== 'LogisticsInfo'">
            <div v-if="isEdit" id="OrderStatusFlow" class="modalBox">
              <p>
                <i class="leftLine"></i>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`订单流转状态`) }}
                </span>
                <a-icon type="sync" class="text-main" @click="refreshHandle" />
              </p>
              <div class="statusBox">
                <p v-if="formData.supplierReturnOrderSn">
                  {{ $t(`退货单号`) }}：{{ formData.supplierReturnOrderSn }}
                  <a-tag
                    style="font-size: 12px; font-weight: normal; margin-left: 10px"
                    v-if="formData.status"
                  >
                    {{ $t(`form.${formData.status}`) }}
                  </a-tag>
                </p>
                <div
                  v-if="!isShow && isInfoShow && formData.status && formData.status !== 'CANCEL'"
                >
                  <a-button
                    v-if="formData.status === 'WAIT_CHECK'"
                    type="primary"
                    @click="onReview"
                    :loading="reviewLoading"
                  >
                    {{ $t(`form.Review`) }}
                  </a-button>
                  <a-button
                    class="btnBgc"
                    type="primary"
                    @click="onPush"
                    :loading="pushLoading"
                    v-if="formData.status === 'WAIT_PUSH'"
                  >
                    {{ $t(`form.Push`) }}
                  </a-button>
                  <a-button
                    v-if="formData.status && formData.status != 'FINISH'"
                    type="danger"
                    :loading="voidLoading"
                    @click="onVoidOrderHandle"
                  >
                    {{ $t(`form.VoidOrder`) }}
                  </a-button>
                </div>
              </div>
              <component
                v-if="stateData.length > 0"
                :is="'process-state2'"
                :statedata="stateData"
                :curstate="curState"
                :style-obj="{ stateItem: 130 }"
              ></component>
            </div>
            <div id="ArrivalDetail" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('form.PurchaseReturnInformation') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status !== 'CANCEL'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24" class="flex-row">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`退货仓库`)" :required="true">
                    <SelectWarehouseNew
                      :placeholder="$t(`form.receiverWarehouse`)"
                      style="width: 100%"
                      :disabled="isDisabled"
                      :code.sync="formData.warehouseCode"
                      @selected="selectedWarehouse"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`采购单号`)" :required="true">
                    <SelectPurchase
                      :warehouseCode="formData.warehouseCode"
                      :defaultValue="formData.associatedOrderSn"
                      :disabled="this.isEdit || !formData.warehouseCode"
                      @selected="selectPurchaseChange"
                    ></SelectPurchase>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.supplierName`)" :required="true">
                    <a-input v-if="isDisabled" :value="formData.supplierName" disabled />
                    <selectSupplier
                      v-else
                      :code="formData.supplierCode"
                      @supplierIndexChange="supplierIndexChange"
                    ></selectSupplier>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.SupplierContactInformation`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.supplierMobile"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.supplierMobile`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.SupplierAddress`)" :required="true">
                    <a-input disabled v-model="formData.supplierAddress" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.Postcode`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.supplierPostCode"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.Postcode`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`快递`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`快递`)"
                      style="width: 100%"
                      v-model="formData.shippingCode"
                      :disabled="isDisabled"
                    >
                      <!--写死 SF、JD、EMS -->
                      <a-select-option value="SF">{{ $t('顺丰') }}</a-select-option>
                      <a-select-option value="JD">{{ $t('京东') }}</a-select-option>
                      <a-select-option value="EMS">EMS</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="formData.shippingCode">
                  <a-form-model-item :label="$t(`收件人名称`)" :required="true">
                    <a-input
                      v-model="formData.expressReceiverName"
                      :disabled="isDisabled"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`收件人名称`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="formData.shippingCode">
                  <a-form-model-item :label="$t(`收件人手机号`)" :required="true">
                    <a-input
                      v-model="formData.expressReceiverMobile"
                      :disabled="isDisabled"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`收件人手机号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="formData.shippingCode">
                  <a-form-model-item :label="$t(`快递单号`)" :required="true">
                    <a-input
                      v-model="formData.logisticCode"
                      :disabled="isDisabled"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`快递单号`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8" v-if="formData.shippingCode">
                  <a-form-model-item :label="$t(`快递费`)" :required="true">
                    <a-input
                      v-model="formData.expressFreight"
                      :disabled="isDisabled"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`快递费`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OrderTime`)">
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.createdAt"
                      :disabled="true"
                      :placehold="$t(`form.EstimatedArrivalTime`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.DeliveryOrderNo`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.wmsOrderSn"
                      :placeholder="$t(`form.DeliveryOrderNo`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.PORemarks`)">
                    <a-input
                      :disabled="isEdit && (!isEdit || !isShow)"
                      v-model="formData.note"
                      :placeholder="$t(`form.PORemarks`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
          <div id="ProductInfo" class="modalBox" v-show="activeKey !== 'LogisticsInfo'">
            <a-form-model>
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  {{ $t('form.ProductInfo') }}
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isInfoShow = !isInfoShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createInfoForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelInfoEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
                <div class="txt">
                  <span style="margin-right: 30px">
                    {{ $t('数量合计') }}: {{ purchaseAllQuantity | toThousands }}
                  </span>
                </div>
              </div>
              <a-row
                v-if="!editShow || (editShow && !isInfoShow)"
                style="display: flex; justify-content: space-between"
              >
                <a-col style="position: relative; flex: 1">
                  <SearchSku
                    style="width: 300px"
                    :placeholder="$t(`form.PleaseEnterProductName`)"
                    @selected="handleChangeSku"
                  />
                  <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('form.Add') }}
                  </a-button>
                  <a-button type="primary" @click="showModal">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t(`form.BatchImport`) }}
                  </a-button>
                </a-col>
                <a-col class="flex-ct">
                  {{ $t('按') }}
                  <SelectUnitType
                    class="ml6 mr6"
                    style="flex: 1"
                    :code.sync="unitType"
                    @change="changeUnitType"
                  />
                  {{ $t('单位创建') }}
                </a-col>
              </a-row>
              <a-row>
                <div class="table-wrapper" style="margin-top: 10px">
                  <!--每个列的宽度必须比列名总长度大才能使表格所有列对齐，留一个列不设置宽度  :rowSelection="{selectedRowKeys: selectedRowKeys}"-->
                  <a-table
                    :columns="columns"
                    :dataSource="tableData"
                    bordered
                    size="middle"
                    :loading="tableLoading"
                    :pagination="false"
                    :scroll="{ x: 1500 }"
                    :rowKey="
                      (record, index) => {
                        return index
                      }
                    "
                  >
                    <span slot="no" slot-scope="text, record, index">
                      {{ index + 1 }}
                    </span>
                    <span slot="unitSelect" slot-scope="text, record">
                      <SelectUnit
                        :disabled="isInfoShow"
                        :skuCode="record.barcode"
                        :list="record.unitList"
                        :code.sync="record.unit"
                      />
                    </span>
                    <span slot="currentQuantity" slot-scope="text, record">
                      <MulUnitShow :list="record.unitList" :amount="text" />
                    </span>
                    <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                      <div :key="col">
                        <!-- includes 用来判断当前的输入类型 -->

                        <a-input-number
                          :read-only="readonlyArr.includes(col)"
                          :placeholder="$t(`form.PleaseEnter`)"
                          :formatter="Formatter"
                          :parser="Formatter"
                          v-if="col === 'returnQuantity'"
                          :value="text"
                          :disabled="isInfoShow"
                          @change="(e) => handleChange(e, record.key, col, index)"
                        />
                        <a-input
                          :read-only="readonlyArr.includes(col)"
                          :placeholder="$t(`form.PleaseEnter`)"
                          v-else-if="inputScopedSlots.includes(col)"
                          :value="text"
                          :disabled="isInfoShow"
                          @change="(e) => handleChange(e.target.value, record.key, col, index)"
                        />
                        <a-select
                          :placeholder="$t(`form.pleaseChoose`)"
                          style="display: block"
                          v-else-if="col === 'inventoryStatus'"
                          :value="text"
                          :disabled="isInfoShow"
                          @change="onChangeSelect($event, record.barcode, col, index)"
                        >
                          <a-select-option value="CERTIFIED_PRODUCTS">
                            {{ $t('正品') }}
                          </a-select-option>
                          <a-select-option value="DEFECTIVE_PRODUCTS">
                            {{ $t('次品') }}
                          </a-select-option>
                        </a-select>
                        <div v-else-if="col === 'inventoryNote'">
                          <div>{{ record.inventoryNote }}</div>
                          <a
                            v-if="isRent && formData.status === 'WAIT_CHECK'"
                            style="margin-left: 8px"
                            @click="openInventoryBatchModal(record)"
                          >
                            {{ $t('指定批次发货') }}
                          </a>
                        </div>
                        <a v-else-if="col === 'delect'" @click="onDelect(index)">
                          <a-icon type="delete" style="color: red" />
                        </a>
                        <span v-else>{{ text | toThousands }}</span>
                      </div>
                    </template>
                  </a-table>
                </div>
              </a-row>
            </a-form-model>
          </div>
          <div
            id="PlatformRefund"
            class="modalBox"
            v-show="activeKey !== 'LogisticsInfo' && isEdit && formData.canPlatformRefund"
          >
            <PlatformRefundPanel
              :supplierReturnOrderId="supplierReturnOrderId"
              :canPlatformRefund="!!formData.canPlatformRefund"
            />
          </div>
          <div id="LogisticsInfo" class="modalBox" v-show="activeKey === 'LogisticsInfo'">
            <div class="infoTitle">
              <div>
                <i class="leftLine"></i>
                <span>{{ $t('物流信息') }}</span>
              </div>
            </div>
            <TrackingRoute
              :order-id="supplierReturnOrderId"
              :expressCode="formData.shippingCode"
              :expressSn="formData.logisticCode"
            />
          </div>
        </section>
        <OperationLog :list="orderActions" v-show="activeKey !== 'LogisticsInfo'" />
      </div>

      <div class="content" style="min-height: 0" v-if="!isEdit">
        <a-row type="flex" justify="center">
          <a-col v-if="formData.status !== 'CANCEL'">
            <a-row type="flex" justify="start" :gutter="16">
              <a-button type="default" @click="backForm(1)">{{ $t(`form.Back`) }}</a-button>
              <a-button
                v-if="editShow && formData.status !== 'FINISH'"
                type="primary"
                @click="onEdit"
              >
                {{ $t(`form.Edit`) }}
              </a-button>
              <a-button
                v-else-if="formData.status !== 'FINISH'"
                type="primary"
                :loading="submitLoadng"
                @click="onSubmit"
              >
                {{ $t(`form.Save`) }}
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <!-- 导入采购商品信息数据 -->
    <a-modal
      class="importModal"
      v-model="isImportData"
      :title="modalInfo.modalTitle"
      :width="500"
      :footer="null"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :data="{ buId: buId, warehouseCode: formData.warehouseCode }"
          :headers="{ Authorization: sessionId }"
          @change="importData"
          :action="modalInfo.modalUrl + `?language=${this.language_mapping[this.lang]}`"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          class="text-info mt10"
          download
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }} {{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
    <InventoryBatchSelectModal
      :visible.sync="inventoryBatchModalVisible"
      :title="$t('指定库存批次')"
      :barcode="inventoryBatchBarcode"
      :warehouseCode="inventoryBatchWarehouseCode"
      :updateUrl="updateUrl"
      :orderId="supplierReturnOrderId"
      orderIdParamName="supplierReturnOrderId"
      :orderItemId="inventoryBatchGoodsId"
      orderItemIdParamName="supplierReturnOrderGoodsId"
      @saved="handleInventoryBatchSaved"
    />
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import selectSupplier from '@component/selectSupplier'
import { mapGetters, mapState } from 'vuex'
import DatePicker from '@component/datePicker'
import { add } from '@/common/number'
import { getCookie } from '@/common/cookie'
import processState2 from '@component/processState2'
import SearchSku from '@component/searchSku'
import OperationLog from '@component/operationLog'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import debounce from '@/common/debounce'
import SelectUnit from '@component/selectUnit'
import SelectUnitType from '@component/selectUnitType'
import MulUnitShow from '@component/mulUnitShow'
import SelectPurchase from '@component/selectPurchase'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import InventoryBatchSelectModal from '@component/inventoryBatchSelectModal.vue'
import TrackingRoute from '@component/TrackingRoute.vue'
import PlatformRefundPanel from '@component/platformRefundPanel.vue'

export default {
  name: 'addPurchaseReturnDetail',
  components: {
    selectSupplier,
    processState2,
    SearchSku,
    DatePicker,
    OperationLog,
    SelectUnit,
    SelectUnitType,
    MulUnitShow,
    SelectPurchase,
    SelectWarehouseNew,
    InventoryBatchSelectModal,
    TrackingRoute,
    PlatformRefundPanel,
  },
  data() {
    return {
      loading: false,
      editShow: false,
      isEdit: false,
      isShow: false,
      isInfoShow: false,
      supplierReturnOrderId: '',
      orderActions: [],
      // 表格数据
      tableData: [],
      // 每一列的插槽名 - 表格行内编辑用
      customRenderList: [
        'note',
        'inventoryNote',
        'delect',
        'returnQuantity',
        'inventoryStatus',
        // "skuNumber",
      ],
      // 用来匹配插槽中显示input框
      inputScopedSlots: [
        'note',
        // "skuNumber",
      ],
      // 用来匹配插槽中显示select框
      selectScopedSlots: ['caseUnit', 'currency'],
      // 对于某些自动赋值的input框设为 只读
      readonlyArr: [''],
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      provinceList: [],
      formData: {
        isItemIncludeTax: false,
      },
      selectedGoodsOrGroup: {},
      selectedGoodsOrGroupArray: [],
      currentGood: {},
      data: [],
      selectOptionsLoading: false,
      isImportData: false, //批量导入弹窗
      modalInfo: {
        modalTitle: this.$t('批量导入采购退货单明细'),
        modalDesc: '',
        modalUrl: api.batchImportSupplierReturnOrderGoods,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      }, //批量导入模板信息
      sessionId: '',
      stateData: [],
      pageNo: 1,
      pageSize: 20,
      pages: '',
      curState: [],
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      purchaseAllQuantity: 0,
      purchaseAllAmount: 0,
      options: [],
      delivery: [],
      voidLoading: false,
      reviewLoading: false,
      pushLoading: false,
      submitLoadng: false,
      unitType: 'procurementUnit',
      activeKey: 'ArrivalDetail',
      // 指定库存批次弹窗上下文
      inventoryBatchModalVisible: false,
      inventoryBatchBarcode: '',
      inventoryBatchWarehouseCode: '',
      inventoryBatchGoodsId: 0,
    }
  },
  mounted() {
    this.sessionId = getCookie('d_session_id')
    this.getDetail()
    let purchaseOrderId = this.$route.query.purchaseOrderId
    if (purchaseOrderId) {
      this.getPurchaseOrderDetail(purchaseOrderId)
    }
  },
  computed: {
    ...mapState(['userSession']),
    ...mapGetters(['isRent']),
    updateUrl() {
      return api.updateSupplierReturnOrderItemInventoryInfo
    },
    lang() {
      return this.$store.state.lang
    },
    buId() {
      return this.$store.getters.partyId
    },
    isDisabled() {
      return this.isEdit && (!this.isEdit || !this.isShow || this.formData.status !== 'WAIT_CHECK')
    },
    columns() {
      let list = [
        {
          title: 'NO',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        {
          title: this.$t(`form.ProductName`),
          align: 'center',
          dataIndex: 'productName',
          width: 120,
        },
        {
          title: this.$t(`form.ProductBarcode`),
          align: 'center',
          dataIndex: 'barcode',
          width: 120,
        },
        {
          title: this.$t(`form.ProductSpecifications`),
          align: 'center',
          dataIndex: 'productStyle',
          width: 120,
        },
        {
          title: this.$t('库存类型'),
          align: 'center',
          dataIndex: 'inventoryStatus',
          key: 'inventoryStatus',
          width: 120,
          scopedSlots: {
            customRender: 'inventoryStatus',
          },
        },
        {
          title: this.$t('商品库存'),
          align: 'center',
          dataIndex: 'currentQuantity',
          key: 'currentQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'currentQuantity',
          },
        },
        {
          title: this.$t('form.DeliveryQuantity'),
          align: 'center',
          key: 'returnQuantity',
          dataIndex: 'returnQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'returnQuantity',
          },
        },
        {
          title: this.$t('单位'),
          align: 'center',
          dataIndex: 'unit',
          width: 100,
          scopedSlots: {
            customRender: 'unitSelect',
          },
        },
        {
          title: this.$t(`form.Remark`),
          align: 'center',
          key: 'note',
          dataIndex: 'note',
          width: 120,
          scopedSlots: {
            customRender: 'note',
          },
        },
        ...(this.isRent
          ? [
              {
                title: this.$t('库存来源'),
                align: 'center',
                key: 'inventoryNote',
                dataIndex: 'inventoryNote',
                width: 140,
                scopedSlots: {
                  customRender: 'inventoryNote',
                },
              },
            ]
          : []),
        {
          title: this.$t(`form.skuNumber`),
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
        },
        {
          title: this.$t(`form.Category`),
          align: 'productCategory',
          dataIndex: 'productCategory',
          width: 120,
          scopedSlots: {
            customRender: 'category',
          },
        },
      ]
      if (!this.isInfoShow) {
        list.push(
          ...[
            {
              title: this.$t(`form.Operation`),
              align: 'center',
              dataIndex: 'delect',
              width: 120,
              scopedSlots: {
                customRender: 'delect',
              },
            },
          ]
        )
      }
      return list
    },
    scrollHeight() {
      let height = window.innerHeight - (this.isEdit ? 220 : 300)
      return height * this.$store.state.rate + 'px'
    },
  },
  watch: {
    tableData: {
      handler: function (data) {
        this.purchaseAllQuantity = data.reduce((a, b) => add(a, Number(b.returnQuantity) || 0), 0)
      },
    },
  },
  methods: {
    Formatter: formatter,
    queryTrackingRoute() {},
    openInventoryBatchModal(record) {
      if (!this.supplierReturnOrderId) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('当前单据ID缺失，无法指定批次'),
        })
        return
      }
      const goodsId =
        record?.supplierReturnOrderGoodsId ||
        record?.supplierReturnOrderItemId ||
        record?.supplierReturnOrderGoodsReqId ||
        record?.id
      if (!goodsId) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('当前商品缺少供应退货单商品ID，无法指定批次'),
        })
        return
      }
      if (!record?.barcode) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('当前商品条码缺失，无法查询库存明细'),
        })
        return
      }
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t('layer.Warning'),
          content: this.$t('layer.PleaseReceivingWarehouse') || '请先选择退货仓库',
        })
        return
      }
      this.inventoryBatchBarcode = record.barcode
      this.inventoryBatchWarehouseCode = this.formData.warehouseCode
      this.inventoryBatchGoodsId = goodsId
      this.inventoryBatchModalVisible = true
    },
    async handleInventoryBatchSaved() {
      // 重新拉取明细，展示库存来源/批次结果
      this.getDetail()
    },
    refreshHandle() {
      this.getDetail()
    },
    async loadData(selectedOptions) {
      this.type = selectedOptions.length
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      await http({
        url: api.getRegionAdd,
        type: 'post',
        data: {
          regionType: this.type,
          parentId: targetOption.region_id,
        },
        success: (res) => {
          let data = res.result
          targetOption.loading = false
          targetOption.children = [...data]
          if (this.type <= 3) {
            targetOption.children = [...data].map((item) => {
              item.isLeaf = selectedOptions.length === 3 // deep 为指名数据的层级
              return item
            })
          }

          this.options = [...this.options]
        },
      }) // 接口调用
    },
    supplierIndexChange(val) {
      // console.log('supplierVal', val)
      var obj = {
        supplierName: val.supplierName,
        supplierCode: val.supplierCode,
        address: val.address,
        supplierPostCode: val.postCode,
        supplierMobile: val.supplierMobile,
        bankAccount: val.bankAccount,
        openingBank: val.openingBank,
        supplierAddress: val.provinceName + val.cityName + val.districtName + val.address,
        supplierProvince: val.province,
        supplierCity: val.city,
        supplierDistrict: val.district,
        supplierCountry: val.country,
      }
      this.formData = { ...this.formData, ...obj }
    },
    async getDetail() {
      if (this.$route.query.id) {
        this.loading = true
        this.supplierReturnOrderId = this.$route.query.id
        this.getOrderActionList()
        this.editShow = true
        this.isEdit = true
        this.isInfoShow = true
        this.queryTrackingRoute()
        await http({
          url: api.supplierReturnOrderDetail,
          type: 'post',
          data: {
            supplierReturnOrderId: this.supplierReturnOrderId,
          },
          success: (res) => {
            this.tableData = res.result.supplierReturnOrderResVOS.sort((a, b) => {
              a.skuNumber - b.skuNumber
            })
            this.tableData.forEach((item) => {
              item.currentQuantity =
                item.inventoryStatus == 'CERTIFIED_PRODUCTS'
                  ? item?.skuStockVo?.availableQuantity
                  : item?.skuStockVo?.defectiveQuantity
            })
            this.formData = res.result
            this.$forceUpdate()
            this.getOrderProcess()
          },
        })
        this.loading = false
      }
    },
    createForm() {
      if (this.formData.shippingCode) {
        if (!this.formData.expressReceiverName) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入收件人名称`) })
          return
        }
        if (!this.formData.expressReceiverMobile) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入收件人手机号`) })
          return
        }
        if (!this.formData.logisticCode) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入快递单号`) })
          return
        }
        if (!this.formData.expressFreight) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入快递费`) })
          return
        }
      }
      let formData = deepClone(this.formData)
      http({
        url: api.updateSupplierReturnOrderInfo,
        type: 'post',
        data: {
          ...formData,
        },
        hasLoading: false,
        success: () => {
          this.getOrderActionList()
          this.editShow = true
          this.isEdit = true
          http({
            url: api.supplierReturnOrderDetail,
            type: 'post',
            data: {
              supplierReturnOrderId: this.supplierReturnOrderId,
            },
            success: (res) => {
              this.formData = res.result
              this.$forceUpdate()
              this.getOrderProcess()
            },
          })
          this.isShow = !this.isShow
        },
      })
    },
    createInfoForm() {
      let repeatBarcodeList = []
      this.tableData.forEach((res) => {
        let item = res.barcode + res.inventoryStatus
        if (!repeatBarcodeList.includes(item)) {
          repeatBarcodeList.push(item)
        } else {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`商品列表中包含重复商品`),
          })
          throw Error()
        }
        if (!res.returnQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.PleaseQuantity`),
          })
          throw Error()
        }
      })
      http({
        url: api.updateSupplierReturnOrderItems,
        type: 'post',
        data: {
          supplierReturnOrderId: this.supplierReturnOrderId,
          supplierReturnOrderGoodsReqVOS: this.tableData,
        },
        hasLoading: false,
        success: () => {
          this.isInfoShow = !this.isInfoShow
          this.getDetail()
        },
      })
    },
    cancelEdit() {
      this.getDetail()
      this.isShow = !this.isShow
    },
    cancelInfoEdit() {
      this.isInfoShow = !this.isInfoShow
      this.getDetail()
    },
    getOrderActionList() {
      const _self = this
      http({
        url: api.supplierReturnOrderActionList,
        type: 'post',
        data: {
          supplierReturnOrderId: _self.supplierReturnOrderId,
        },
        hasLoading: false,
        success(res) {
          _self.orderActions = res.result
        },
      })
    },
    handleChangeSku(data) {
      this.currentGood = data
    },
    handleChange(value, rowKey, colName, index) {
      const newData = [...this.tableData]
      const target = newData.filter((item) => rowKey === item.key)[index]
      if (target) {
        target[colName] = value
        this.tableData = newData
      }
    },
    // select 框 change
    onChangeSelect($event, rowKey, colName, index) {
      const newData = [...this.tableData]
      let item = deepClone(newData[index])
      item['inventoryStatus'] = $event
      if ($event == 'CERTIFIED_PRODUCTS') {
        item['currentQuantity'] = item?.skuStockVo?.availableQuantity
      } else {
        item['currentQuantity'] = item?.skuStockVo?.defectiveQuantity
      }
      this.$set(newData, index, item)
      this.tableData = [...newData]
    },
    onDelect(index) {
      const newData = [...this.tableData]
      newData.splice(index, 1)
      this.tableData = newData
    },
    async querySkuStock(barcodeList) {
      let res = await http({
        url: api.querySkuStock,
        type: 'post',
        data: {
          barcodeList,
          warehouseCode: this.formData.warehouseCode,
        },
      })
      return Promise.resolve(res.result)
    },
    async addGoodsToTable() {
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (this.currentGood.skuName) {
        let stockInfoList = await this.querySkuStock([this.currentGood.barcode])
        this.currentGood.productCategory =
          this.currentGood.categoryName || this.currentGood.category //类目
        this.currentGood.productName = this.currentGood.skuName
        this.currentGood.productStyle = this.currentGood.skuStyleValue //规格
        this.currentGood.skuNumber = this.currentGood.brandSku //品牌款号
        this.currentGood.supplierSkuCode = this.currentGood.supplierSku //供应商款号
        this.currentGood.editable = true
        this.currentGood.skuStockVo = {}
        let targetUnit = this.currentGood.unitList?.find((elem) => elem[this.unitType]) || {}
        this.currentGood.unit = targetUnit.unitNameFull
        this.currentGood.skuStockVo.availableQuantity =
          stockInfoList[this.currentGood.barcode].availableQuantity
        this.currentGood.skuStockVo.defectiveQuantity =
          stockInfoList[this.currentGood.barcode].defectiveQuantity
        this.tableData.push(this.currentGood)
      }
    },
    selectedWarehouse(data) {
      if (!data) return
      this.formData.wmsAppCode = data.wmsAppCode
      this.formData.wmsWarehouseCode = data.code
    },
    onEdit() {
      this.editShow = false
      this.isEdit = false
      this.tableData.forEach((item) => {
        item.editable = true
      })
    },
    onSubmit: debounce(function () {
      if (!this.formData.supplierName) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseSupplier`),
        })
        return
      }
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (this.formData.shippingCode) {
        if (!this.formData.expressReceiverName) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入收件人名称`) })
          return
        }
        if (!this.formData.expressReceiverMobile) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入收件人手机号`) })
          return
        }
        if (!this.formData.logisticCode) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入快递单号`) })
          return
        }
        if (!this.formData.expressFreight) {
          this.$warning({ title: this.$t(`layer.Warning`), content: this.$t(`请输入快递费`) })
          return
        }
      }
      // if (!this.formData.supplierPostCode) {
      //   this.$warning({
      //     title: this.$t(`layer.Warning`),
      //     content: _self.$t(`layer.Postcode`),
      //   })
      //   return
      // }
      // if (!this.formData.supplierAddress) {
      //   this.$warning({
      //     title: this.$t(`layer.Warning`),
      //     content: _self.$t(`layer.SupplierDetailedAddress`),
      //   })
      //   return
      // }
      let repeatBarcodeList = []
      this.tableData.forEach((res) => {
        let item = res.barcode + res.inventoryStatus
        if (!repeatBarcodeList.includes(item)) {
          repeatBarcodeList.push(item)
        } else {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`商品列表中包含重复商品`),
          })
          throw Error()
        }
        if (!res.returnQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.PleaseQuantity`),
          })
          throw Error()
        }
      })
      if (this.supplierReturnOrderId) {
        this.updatePurchaseOrderInfo(this.formData)
        this.updatePurchaseOrderItems()
      } else {
        let currentShop = JSON.parse(localStorage.getItem('currentShop'))
        if (currentShop === undefined || currentShop === null || currentShop === '') {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.NoOwnerInformation`),
          })
          return
        }
        const data = this.formData
        data.shopCode = currentShop.uniqueCode
        data.buId = this.$store.getters.partyId
        data.supplierReturnOrderGoodsReqVOS = this.tableData
        data.supplierReturnOrderId = this.supplierReturnOrderId
        this.submitLoadng = true
        http({
          url: api.supplierReturnOrderSave,
          data,
          type: 'post',
          hasLoading: true,
          success: (res) => {
            this.submitLoadng = false
            if (res.success && res.result.supplierReturnOrderId) {
              this.$success({
                title: this.$t(`layer.Success`),
                content: this.$t(`layer.SavingSucceeded`),
              })
              this.backForm()
            } else {
              this.$error({
                title: this.$t(`layer.Error`),
                content: this.$t(`layer.CreateFailed`),
              })
            }
          },
          fail: (res) => {
            this.submitLoadng = false
            this.$error(res.msg)
          },
        })
      }
    }),
    updatePurchaseOrderInfo(data) {
      data.supplierReturnOrderId = this.supplierReturnOrderId
      http({
        url: api.updatePurchaseOrderInfo,
        data,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.supplierReturnOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    updatePurchaseOrderItems() {
      http({
        url: api.updatePurchaseOrderItems,
        data: {
          supplierReturnOrderId: this.supplierReturnOrderId,
          supplierReturnOrderGoodsReqVOS: this.tableData,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.supplierReturnOrderId) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    handleOk() {
      this.$router.push({
        path: '/addAdvancedShippingNote',
        query: {
          supplierReturnOrderId: this.supplierReturnOrderId,
        },
      })
    },
    onReview: debounce(function () {
      this.reviewLoading = true
      http({
        url: api.supplierReturnOrderCheck,
        data: {
          supplierReturnOrderId: this.supplierReturnOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.supplierReturnOrderId) {
            this.formData.status = res.result.status
            this.getDetail()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
          this.reviewLoading = false
        },
        fail: (res) => {
          this.$message.error(res.msg)
          this.reviewLoading = false
        },
      })
    }),
    onPush: debounce(function () {
      this.pushLoading = true
      http({
        url: api.supplierReturnOrderBatchPush,
        data: {
          supplierReturnOrderIds: [this.supplierReturnOrderId],
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          let result = res.result
          if (result?.failPushedMsgs?.length) {
            let err = result.failPushedMsgs.join(',')
            this.$error(err)
          } else {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t('推送成功'),
            })
            setTimeout(() => {
              this.getDetail()
            }, 1200)
          }
          this.getOrderActionList()
          this.pushLoading = false
        },
      })
    }),
    onVoidOrderHandle: debounce(function () {
      this.$confirm({
        title: this.$t('警告'),
        content: this.$t('是否确认作废'),
        onOk: () => {
          this.onVoidOrder()
        },
      })
    }),
    onVoidOrder: debounce(function () {
      this.voidLoading = true
      http({
        url: api.supplierReturnOrderCancel,
        data: {
          supplierReturnOrderId: this.supplierReturnOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success && res.result.supplierReturnOrderId) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.OrderVoided`),
            })
            this.$route.params.status = 'Cancel'
            this.backForm()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.voidLoading = false
          this.getOrderActionList()
        },
      })
    }),
    backForm(back = 0) {
      if (back) {
        this.$router.back()
      } else {
        this.$router.push({
          path: '/purchaseReturnList',
        })
      }
    },
    // 数组对象根据barcode去重方法
    arrayUnique(arr, barcode) {
      var hash = {}
      return arr.reduce(function (acc, cru, index) {
        if (!hash[cru[barcode]]) {
          hash[cru[barcode]] = { index: index }
          acc.push(cru)
        } else {
          acc.splice(hash[cru[barcode]]['index'], 1, cru)
        }
        return acc
      }, [])
    },
    showModal() {
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseReturnOrder/%E9%87%87%E8%B4%AD%E9%80%80%E8%B4%A7%E5%8D%95%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseReturnOrder/PurchaseReturnOrderItemTemplate.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseReturnOrder/PurchaseReturnOrderItemTemplate.xlsx'
          : ''
    },
    // 导入商品信息数据
    importData(info) {
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          resultArr.forEach((item) => {
            item.currentQuantity =
              item.inventoryStatus == 'CERTIFIED_PRODUCTS'
                ? item?.skuStockVo?.availableQuantity
                : item?.skuStockVo?.defectiveQuantity
          })
          // push到表格列表中
          this.tableData.push(...resultArr)
          this.formData.supplierReturnOrderGoodsReqVOS = this.tableData
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.isImportData = false
    },
    getOrderProcess() {
      this.stateData = [
        {
          state: 'create',
          name: 'Create', //创建
          time: this.formData.createdAt,
          status: this.formData.status,
        },
        {
          state: 'check',
          name: 'Review', //审核
          time: this.formData.status == undefined ? '' : this.formData.checkTime,
          status: this.formData.status,
        },
        {
          state: 'Push',
          name: 'Push', //推送
          time: this.formData.status == undefined ? '' : this.formData.pushTime,
          status: this.formData.status,
        },
        {
          state: 'OutWarehouse',
          name: 'OutWarehouse', //出库
          time: this.formData.status == undefined ? '' : this.formData.deliveryTime,
          status: this.formData.status,
        },
        {
          state: 'Complete',
          name: 'Complete', //完成
          time: this.formData.finishTime,
          status: this.formData.status,
        },
      ]

      if (this.formData.status == 'CANCEL') {
        this.curState = {
          state: '',
        }
      } else if (this.formData.status == 'WAIT_PUSH' || this.formData.status == 'PUSH_FAIL') {
        this.curState = {
          state: 'check',
        }
      } else if (this.formData.status == 'WAIT_OUTBOUND') {
        this.curState = {
          state: 'Push',
        }
        this.stateData[this.stateData.length - 1].time = ''
      } else if (this.formData.status === 'FINISH') {
        this.curState = {
          state: 'Complete',
        }
      }
    },
    changeTabs(value) {
      if (value !== 'LogisticsInfo') {
        this.$nextTick(() => {
          document.querySelector(`#${value}`).scrollIntoView(true)
        })
      }
    },
    changeUnitType() {
      this.$nextTick(() => {
        this.tableData.forEach((item) => {
          let targetUnit = item.unitList?.find((elem) => elem[this.unitType]) || {}
          item.unit = targetUnit.unitNameFull
        })
      })
    },
    async selectPurchaseChange(data) {
      // console.log(data)
      if (data.status === 'PART_INBOUND' || data.status === 'FINISH') {
        //部分入库或者完成
        this.getPurchaseOrderDetail(data.purchaseOrderId)
      } else {
        this.$message.error(this.$t('该采购单还未入库或已作废'))
      }
    },
    async getPurchaseOrderDetail(purchaseOrderId) {
      let res = await http({
        url: api.purchaseOrderDetail,
        type: 'post',
        hasLoading: true,
        data: {
          purchaseOrderId,
        },
      })
      this.formData.warehouseCode = res.result.warehouseCode
      this.formData.associatedOrderSn = res.result.purchaseOrderSn
      this.formData.supplierCode = res.result.supplierCode
      this.formData.supplierName = res.result.supplierName
      let goodsList = res.result.purchaseOrderItemResVOS.sort((a, b) => {
        a.skuNumber - b.skuNumber
      })
      goodsList.forEach((goodsItem) => {
        if (goodsItem.deliveryTime) {
          goodsItem.deliveryTime = goodsItem.deliveryTime.split(' ')[0]
        }
        goodsItem.unit = goodsItem.caseUnit
      })

      let stockInfoList = await this.querySkuStock(goodsList.map((item) => item.barcode))
      goodsList.forEach((item) => {
        let obj = stockInfoList[item.barcode]
        item.skuStockVo = {
          availableQuantity: obj.availableQuantity,
          defectiveQuantity: obj.defectiveQuantity,
        }
        item.unitList = obj.unitList
      })
      this.tableData = goodsList
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  margin-right: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
</style>
